export enum JobCompletionStatus {
  Requested = 'requested',
  Scheduled = 'scheduled',
  Reschedule = 'reschedule_requested',
  Cancelled = 'cancelled',
  Completed = 'completed',
  InProgress = 'in_progress',
}

export enum BundleStatus {
  Draft = 'draft',
  Offered = 'offered',
  Accepted = 'accepted',
  Declined = 'declined',
  Expired = 'expired',
}

export enum BundleOfferStatus {
  Pending = 'pending',
  Offered = 'offered',
  Accepted = 'accepted',
  Declined = 'declined',
  Expired = 'expired',
  Unavailable = 'unavailable',
}

export enum JobsFilterType {
  Today = 'Today',
  Tomorrow = 'Tomorrow',
  GoAnytime = 'Go Anytime',
}
